import { getSitecoreComponentDataAsync } from '@store/reducers/vehicleinformation';
import { LeaseConfiguratorConfig } from 'interface';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from './statehooks';

export const useSitcoreComponentData = () => {
  const siteConfigConfig = useAppSelector(
    (state) => state.vehicleInformation.siteCoreDetails?.config
  );
  const [sitecoreReady, setReady] = useState<boolean>(false);
  const [config, setConfig] = useState<LeaseConfiguratorConfig>(
    siteConfigConfig as LeaseConfiguratorConfig
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSitecoreComponentDataAsync());
  });

  useEffect(() => {
    if (siteConfigConfig != null) {
      setConfig(siteConfigConfig);
      setReady(true);
    }
  }, [siteConfigConfig]);

  return { sitecoreReady, config };
};
